import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { size } from "@clockwise/web-commons/src/styles/type.styles";
import { colors, greys } from "@clockwise/web-commons/src/styles/color.styles";
import spacing from "@clockwise/web-commons/src/styles/spacing.styles";

export const container: CSSProperties = {
  // FIXME: WebkitFontSmoothing
  padding: spacing.lg,
  fontSize: size.md,
  color: greys.white,
  backgroundColor: colors.blueCool.standard,
  transition: "all .35s",
  WebkitFontSmoothing: "antialiased",
};

export const hidden: CSSProperties = {
  ...container,
  visibility: "hidden",
  paddingTop: 0,
  paddingBottom: 0,
  height: 0,
  overflow: "hidden",
  transition: "all .35s",
};

const header: CSSProperties = {
  color: greys.white,
};

const body: CSSProperties = {
  lineHeight: 1.5,
};

export const button: CSSProperties = {
  marginTop: spacing.sm,
  minWidth: 100,
  borderColor: greys.white,
  color: greys.white,
  borderRadius: 1000000,
  "&:hover": {
    backgroundColor: greys.white,
    color: colors.blueCool.standard,
  },
};

export const styles = {
  container,
  hidden,
  header,
  body,
  button,
};
